export const AuthErrors = {
  e_l: 'email_login',
  p_l: 'phone_login',
  e_s: 'email_signup',
  p_s: 'phone_signup',
} as const
